import { appSearchParamsKeys } from './Routes/searchParamKeys';

export const MAX_PROFILES = 6;
export const MAX_TUNNUS_ACCOUNTS = 6;
export const ANONYMOUS_USER = 'anonymous';

export const profileColors = [
  '#71b0ff',
  '#88eac7',
  '#f77898',
  '#b7a8fa',
  '#ffe387',
  '#feb054',
] as const;

export const oldProfileColors = [
  'rgba(102, 157, 225, 0.4)',
  'rgba(3, 229, 146, 0.4)',
  'rgba(245, 81, 122, 0.4)',
  'gba(186, 114, 213, 0.4)',
  'rgba(247, 211, 80, 0.4)',
  'rgba(255, 156, 49, 0.4)',
] as const;

type ColorAltText = {
  fi: string;
  sv: string;
};

export const profileColorAltTexts: Record<string, ColorAltText> = {
  '#71b0ff': {
    fi: 'sinisellä taustalla',
    sv: 'på blå bakgrund',
  },
  '#88eac7': {
    fi: 'vihreällä taustalla',
    sv: 'på grön bakgrund',
  },
  '#f77898': {
    fi: 'punaisella taustalla',
    sv: 'på röd bakgrund',
  },
  '#b7a8fa': {
    fi: 'violetilla taustalla',
    sv: 'på violett bakgrund',
  },
  '#ffe387': {
    fi: 'keltaisella taustalla',
    sv: 'på gul bakgrund',
  },
  '#feb054': {
    fi: 'oranssilla taustalla',
    sv: 'på orange bakgrund',
  },
};
export const LAUNCHER_REDIRECT = appSearchParamsKeys.uri;
